import { render } from "./StatsPage.vue?vue&type=template&id=3044557b&scoped=true"
import script from "./StatsPage.vue?vue&type=script&lang=js"
export * from "./StatsPage.vue?vue&type=script&lang=js"

import "./StatsPage.vue?vue&type=style&index=0&id=3044557b&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3044557b"]])

export default __exports__